import { api } from "../utils/api";
import type { RestStockWarning } from "@KassaroAB/shared/types/stockWarning";
import type { StockLocationId, StoreId } from "@KassaroAB/shared/types/ids";

export const getStockWarningsApi = (
  storeId: StoreId,
  stockLocationId: StockLocationId | null,
): Promise<RestStockWarning[]> => {
  return api.get(
    `stores/${storeId}/stockWarnings${stockLocationId ? `?stockLocationId=${stockLocationId}` : ""}`,
  );
};
